export { default as CorporateHeader } from "./corporateheader/CorporateHeader";
export { default as CorporateHeaderEdit } from "./corporateheader/CorporateHeaderEdit";
export { default as CorporateHero } from "./corporatehero/CorporateHero";
export { default as CorporateHeroEdit } from "./corporatehero/CorporateHeroEdit";
export { default as CorporateFeatures } from "./corporatefeatures/CorporateFeatures";
export { default as CorporateFeaturesEdit } from "./corporatefeatures/CorporateFeaturesEdit";
export { default as CorporatePricing } from "./corporatepricing/CorporatePricing";
export { default as CorporatePricingEdit } from "./corporatepricing/CorporatePricingEdit";
export { default as CorporateFooter } from "./corporatefooter/CorporateFooter";
export { default as CorporateFooterEdit } from "./corporatefooter/CorporateFooterEdit";
